import {HttpErrorResponse, HttpRequest, HttpStatusCode} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {GlobalMessageService, HttpErrorHandler, Priority} from '@spartacus/core';
import {ConfigService, DcpLoggingService} from '@dcp/configurator';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {skipWhile} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

/**
 * Handles Oauth client errors when a 401 is returned. This is the case for failing
 * authentication requests to OCC.
 */
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class UnauthorizedErrorHandler extends HttpErrorHandler {
  responseStatus = HttpStatusCode.Unauthorized;

  constructor(
    protected globalMessageService: GlobalMessageService,
    private authService: DcpAuthService,
    private configService: ConfigService,
    private injector: Injector
  ) {
    super(globalMessageService);
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    // If the user has no valid token we want him to be logged out, so he can log in
    // Required in case the silent refresh fails, usually due to strict browser security settings
    if (this.configService.isKymaUrl(request?.url) || request?.url?.includes(this.configService.getString('backend.occ.baseUrl'))) {
      this.injector.get(DcpLoggingService).error(response, this.constructor?.name)
        .pipe(skipWhile(executed => !executed))
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.authService.onAuthenticationError();
        });
    }
  }

  getPriority() {
    return Priority.NORMAL;
  }
}
